// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"158":"7e81fcf9","487":"158f0c04"}[chunkId] + ".chunk.js";
};